export default __webpack_public_path__ + "static/media/agro-logo.2b2fc218.svg";